// extracted by mini-css-extract-plugin
module.exports = {"table":"RateLimitTable_table__cmAzu","toolbar":"RateLimitTable_toolbar__m87bp","toggleSlot":"RateLimitTable_toggleSlot__11cfR","searchField":"RateLimitTable_searchField__DZZcu"};